import React from 'react';
import { ControlledDialog } from './ControlledDialog';
import { CTAButton } from '../../buttons';
import { useTranslation } from 'react-i18next';

type DiscardChangesProps = {
	open: boolean;
	onClose: () => void;
	onDiscard: () => void;
	onCancel: () => void;
};

export const DiscardChanges = ({ open, onClose, onDiscard, onCancel }: DiscardChangesProps) => {
	const { t } = useTranslation();
	return (
		<ControlledDialog
			isOpen={open}
			onClose={onClose}
			icon='danger'
			title={t('titles.discard_changes')}
			body={<p>{t('modals.discard_changes_body', { defaultValue: 'Any unsaved edits will be discarded.' })}</p>}
			footer={
				<>
					<CTAButton buttonText={t('actions.discard_changes')} onClick={onDiscard} variant='dark' textColor='#D92D20' />
					<CTAButton buttonText={t('actions.cancel')} onClick={onCancel} variant='dark' />
				</>
			}
		/>
	);
};
